import React,{useState,useEffect} from "react";

//import icons
import { IoCardOutline } from "react-icons/io5";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { listTenantInvoices } from "../../../../redux/slices/sliceActions";

const PendingIncoicesCard = ({ setShowPay }) => {
    //data fetched from the store
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.landlordslice);
  
    const [invoicesReceived, setInvoicesReceived] = useState([]);
    const [invoices, setInvoices] = useState([]);
    useEffect(() => {
      console.log(user);
      const details = {
        user_id: user?.data?.user?.user_id,
        token: user?.accessToken,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      };
      dispatch(listTenantInvoices({details})).then((res) => {
        console.log("the response",res)
        setInvoicesReceived(res.payload.data?.invoices);
      });
    }, [user]);
  
    useEffect(() => {
      if (invoicesReceived.length > 0) {
        setInvoices(transformInvoices(invoicesReceived));
        console.log("Invoices:", invoices);
      }
    }, [invoicesReceived]);

  const card = {
    backgroundColor: "#ffffff",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.28)",
    minHeight: "55px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  };
  const icon = {
   marginLeft: "10px",
  };
  const invoiceType = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  }
  const dueDate = {
    fontSize: "14px",
    margin:"0px",
  }

  const ammountDisplayed = {
    marginRight:"10px",
  }
  return (
    <>
      {invoices.map((invoice, index) => (
         <button style={{ width: "100%", backgroundColor: "transparent", border: "none" }} onClick={() => {
          setShowPay(true);
          console.log("clicked");
        }}>
            <div style={card}>
          <div style={icon}>
            <IoCardOutline fontSize={25} />
          </div>
          <div style={invoiceType}>
            <div>Rent And Water</div>
              <div style={dueDate}>{ invoice?.dueDate}</div>
          </div>
          <div style={ammountDisplayed}>
            {invoice?.totalAmount}
          </div>  
        </div>
        </button>
      ))}
    
      
      {/* 
       <button style={{ width: "100%", backgroundColor: "transparent", border: "none" }} onClick={() => {
      setShowPay(true);
      console.log("clicked");
    }}>
        <div style={card}>
      <div style={icon}>
        <IoCardOutline fontSize={25} />
      </div>
      <div style={invoiceType}>
        <div>Rent And Water</div>
        <div style={dueDate}>Due in 5 days</div>
      </div>
      <div style={ammountDisplayed}>
        10,000
      </div>  
    </div>
    </button>
  ); */}
    </>
  )
};


function transformInvoices(invoices) {
  console.log("received these invoices", invoices);

  const getRelativeDueDate = (dueDate) => {
    if (!dueDate) return "no due date";

    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Difference in days

    if (diffDays > 0) {
      return `due in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } else if (diffDays < 0) {
      return `${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? 's' : ''} ago`;
    } else {
      return "Today";
    }
  };

  return invoices
    .filter(invoice => invoice.payment_status !== "fully_paid") // Filter out fully paid invoices
    .map((invoice) => {
      // Calculate the total amount by summing up the individual charges
      const totalAmount = (
        parseFloat(invoice.rent_invoice || 0) +
        parseFloat(invoice.water_invoice || 0) +
        parseFloat(invoice.garbage_charge || 0) +
        parseFloat(invoice.service_charge || 0) +
        parseFloat(invoice.late_fee || 0) +
        parseFloat(invoice.arrears || 0)
      ).toFixed(2); // Ensure it's a number with two decimal places

      // Determine the status
      const status = invoice.payment_status === "fully_paid" ? "Paid" : "Unpaid";

      // Calculate total payable amount
      const totalPayable = totalAmount; // Adjust if you need to add any extra charges

      return {
        id: `INV${(invoice.invoice_id || '').padStart(3, "0")}`, // Format ID with leading zeros
        status: status,
        dueDate: getRelativeDueDate(invoice.due_date), // Get relative due date
        totalAmount: invoice?.remaining_balance,
        rent: invoice.remaining_rent || '0',
        water: invoice.remaining_water || '0',
        garbage: invoice.remaining_garbage || '0',
        arrears:invoice?.remaining_arrears || '0',
        otherCharges: (
          parseFloat(invoice.remaining_service_charge || 0) +
          parseFloat(invoice.remaining_late_fee || 0) +
          parseFloat(invoice.arrears || 0) +
          parseFloat(invoice.remaining_unpaid_deposit || 0)
        ).toFixed(2),
        totalPayable: invoice?.remaining_balance,
      };
    });
}


export default PendingIncoicesCard;
